export function vibrateDevice(amount) {
  if (window.navigator && window.navigator.vibrate)
    window.navigator.vibrate(amount);
}
